import { Stack } from '@mui/material';
import { FC } from 'react';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export const ConditionPercentageSkeleton: FC = () => {
  return (
    <Stack direction="row" gap={1} alignItems="center">
      <Stack direction="column" gap={0.5} alignItems="flex-end">
        <ThemedSkeleton variant="text" colorVariant="secondary" width={20} height={26} />
        <ThemedSkeleton variant="rectangular" colorVariant="secondary" width={80} height={10} sx={{ borderRadius: 1 }} />
      </Stack>
    </Stack>
  );
};

